import { render, staticRenderFns } from "./swiper-pc.vue?vue&type=template&id=004ff03e&scoped=true&"
import script from "./swiper-pc.vue?vue&type=script&lang=js&"
export * from "./swiper-pc.vue?vue&type=script&lang=js&"
import style0 from "./swiper-pc.vue?vue&type=style&index=0&id=004ff03e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004ff03e",
  null
  
)

export default component.exports